import React from "react";
import { Tabs } from "antd";
import type { TabsProps } from "antd";
import "./tabs.scss";
import { Tab, TabBarExtraPosition } from "rc-tabs/lib/interface";

const TabsList = (props: {
  items: Tab[] | undefined;
  onChange: (arg0: string) => void;
  extraInfo?: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | Partial<Record<TabBarExtraPosition, React.ReactNode>> | null | undefined;
}) => {
  const items: TabsProps["items"] = props.items;

  const onChange = (key: string) => {
    props.onChange(key);
  };

  return <Tabs className="tab-card-type" type="card" defaultActiveKey="1" items={items} onChange={onChange} tabBarExtraContent={props?.extraInfo ? props?.extraInfo : undefined} />;
};

export default TabsList;
